/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "denied-knockout-5364de27--sprite",
  "use": "denied-knockout-5364de27--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"denied-knockout-5364de27--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(-195.116 15.27)\"><path d=\"M213.116-11.269h-.01a14,14,0,1,0,.01,0Zm6.22,15.54H206.9a1.555,1.555,0,0,1,0-3.11h12.44a1.555,1.555,0,0,1,0,3.11Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
